import { useState, useEffect } from 'react';

const scriptCache = {};

const useScript = (url, attributes = {}, callback = null) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (scriptCache[url]) {
      setLoaded(scriptCache[url].loaded);
      setError(scriptCache[url].error);
      return;
    }

    const script = document.createElement('script');
    script.src = url;
    Object.entries(attributes).forEach(([key, value]) => {
      script.setAttribute(key, value);
    });

    const onScriptLoad = () => {
      setLoaded(true);
      if (callback) callback();
      scriptCache[url].loaded = true;
    };

    const onScriptError = (err) => {
      setError(err);
      scriptCache[url].error = err;
    };

    script.onload = onScriptLoad;
    script.onerror = onScriptError;
    script.addEventListener('load', onScriptLoad);
    script.addEventListener('error', onScriptError);

    document.body.appendChild(script);

    scriptCache[url] = { loaded: false, error: null };

    return () => {
      script.removeEventListener('load', onScriptLoad);
      script.removeEventListener('error', onScriptError);
      return null;
    };
  }, [url, attributes, callback]);
  return [loaded, error];
};

export default useScript;
